import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import PaginatedResponse from '@/types/paginatedResponse';
import { QueryParams } from '@/types/query';
import RepositoryResponse from '@/types/repositoryResponse';
import ajax from '@/utils/ajax';
import defaultRepositoryError from '@/utils/defaultRepositoryError';
import logAjaxError from '@/utils/logAjaxError';

import { ChecklistCategory, ChecklistCategoryParams } from '../types/checklistCategory';

export const checklistCategoryRepository = {
  async getChecklists({
    host,
    params
  }: {
    host: string;
    params: ChecklistCategoryParams;
  }): Promise<RepositoryResponse<PaginatedResponse<ChecklistCategory[]>>> {
    try {
      const path = '/api/dugout/checklists/';
      const response = await ajax.get({
        url: `${host}${path}`,
        params: params as unknown as QueryParams
      });

      return {
        data: response.data,
        isError: false
      };
    } catch (error) {
      logAjaxError(error);
      return defaultRepositoryError(error as AxiosError, 'Failed to get checklists.');
    }
  }
};

const ChecklistCategoryRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getChecklists(
      params: ChecklistCategoryParams
    ): Promise<RepositoryResponse<PaginatedResponse<ChecklistCategory[]>>> {
      return checklistCategoryRepository.getChecklists({ host, params });
    }
  };
};

export default ChecklistCategoryRepository;
